import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    vuexEmpInfo: {},
    // 处理埋点需要的来自哪个页面
    frontPageName: '',
    // 记录所有进入过的UI的路径
    lastPageList: [],
    // 当前查看最后一个的商品详情
    goodsData: {},
    // 分销预备合伙人的id,分享后用户跳转读取 -- 暂时废弃,使用cookies,因为ccfx那边跳过来无法记录
    shareApplyId: ''
  },
  getters: {
    isFormalEmp(state) {
      return state.vuexEmpInfo.regCheckStatus == 1
    },
    isReadPartner(state) {
      // 是不是预备合伙人
      return state.vuexEmpInfo.regEmpType == 0
    },
    getEmpNo(state) {
      return state.vuexEmpInfo.empNo || null
    },
    // 暂时废弃,使用cookies,因为ccfx那边跳过来无法记录
    getShareApplyId(state) {
      return state.shareApplyId || ''
    },
    // 需求新增预备合伙人,拥有申请账号,但是没有合伙人工号
    getApplyId(state) {
      return state.vuexEmpInfo.applyId || null
    },
    getEmpInfo(state) {
      return state.vuexEmpInfo
    },
    getFromUrl(state) {
      let lastPageList = state.lastPageList
      let result = lastPageList.join(',')
      console.log('result', result)
      return result
    },
    getGoodsData(state) {
      return state.goodsData
    },
    getTencentAppCodeList(state) {
      // 1026: '爱奇艺',
      // 1028: '腾讯',
      // 7890: '腾讯APK会员',
      // 7909: '酷喵'
      return ['7890', '1028']
    }

  },
  mutations: {
    // 暂时废弃,使用cookies,因为ccfx那边跳过来无法记录
    setShareApplyId(state, val) {
      console.log('setShareApplyId', val)
      state.shareApplyId = val || ''
    },
    setEmpInfo(state, val) {
      console.log('setEmpInfo', val)
      state.vuexEmpInfo = val || {}
    },
    setGoodsData(state, val) {
      state.goodsData = val
    },
    setLastPageList(state, val) {
      state.lastPageList = val
    },
    pushPageList(state, val) {
      state.lastPageList.push(val)
    }
  },
  actions: {
    // setEventTracking({ state }, {
    //   vm, orderNo
    // }) {
    //   let params = {
    //     orderNo,
    //     eventTrackingInfo: state.lastPageList.join(',')
    //   }
    //   vm.$service.setEventTracking(params)
    // }
  },
  modules: {

  }
})
